import { getId } from 'services/utils'
import { mainProductParse, mainProductWrite } from '../mainProduct'
import { upsellingParse } from '../upselling'
import { ProductWithUpsellingToApi } from './types/api/request-models'
import { APIProductWithUpselling } from './types/api/response-models'
import { ProductWithUpselling } from './types/internal/productWithUpsellings-models'

// ============
// PARSE
// ============

export const productWithUpsellingParse = ({
  upselling,
  ...rest
}: APIProductWithUpselling): ProductWithUpselling => ({
  ...mainProductParse(rest),
  upsellingItemsFull: upselling.map(upsellingParse),
  upsellingItems: upselling.map(getId),
})

// ============
// WRITE
// ============

export const productWithUpsellingWrite = async ({
  upsellingItems,
  ...rest
}: ProductWithUpselling): Promise<ProductWithUpsellingToApi> => ({
  ...(await mainProductWrite(rest)),
  upselling: upsellingItems,
})
